const m = function(i, t) {
  if (i == null || isNaN(i))
    return;
  const n = t.keepTrailingZeroes ? t.precision : 0, e = t.precision;
  return t.format === "percent" && t.max !== void 0 ? new Intl.NumberFormat(t.locale, {
    style: "percent",
    minimumFractionDigits: n,
    maximumFractionDigits: e
  }).format(i / t.max) : new Intl.NumberFormat(t.locale, {
    minimumFractionDigits: n,
    maximumFractionDigits: e
  }).format(i);
};
export {
  m as calculateValue
};
